<script>
	export let data;

	let jsonld = JSON.stringify({
		'@context': 'http://schema.org',
		'@type': 'ItemList',
		itemListElement: [
			{
				'@type': 'ListItem',
				position: 1,
				name: 'Market Cap',
				description: 'Total market capitalization of cryptocurrencies',
				value: data.marketCap,
			},
			{
				'@type': 'ListItem',
				position: 2,
				name: '24H Volume',
				description: 'Total trading volume in the last 24 hours',
				value: data['24HVol'],
			},
			{
				'@type': 'ListItem',
				position: 3,
				name: 'BTC Dominance',
				description: 'Percentage of total market cap represented by Bitcoin',
				value: data.bTCDominance,
			},
			{
				'@type': 'ListItem',
				position: 4,
				name: 'Number of Cryptocurrencies',
				description: 'Total number of cryptocurrencies listed',
				value: data.cryptos,
			},
			{
				'@type': 'ListItem',
				position: 5,
				name: 'Number of Exchanges',
				description: 'Total number of cryptocurrency exchanges',
				value: data.exchanges,
			},
		],
	});

	let jsonldScript = `<script type="application/ld+json">${jsonld + '<'}/script>`;
</script>

<svelte:head>
	{@html jsonldScript}
</svelte:head>
